'use client'
import { useContext } from 'react'
import { PageDesignContext } from '@/context'

export const usePageDesign = () => {
  const ctx = useContext(PageDesignContext)
  if (!ctx) throw new Error('usePageDesign must be used within a PageDesignProvider')
  return ctx
}
